import { botClient, makeServicePlugin, BaseModel } from '@/bot'

class Geofence extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'Geofence'
  // Define default properties here
  static instanceDefaults() {
    return {
      file_id: null,
      name: null,
      feature: {},
      options: {}
    }
  }
}

const servicePath = 'geofences'
const servicePlugin = makeServicePlugin({
  Model: Geofence,
  service: botClient.service(servicePath),
  servicePath
})

// Setup the client-side Feathers hooks.
botClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin